export default function(name) {
  var url = window.location.search.substring(1);
  var vars = url.split('&');
  for (var i = 0; i < vars.length; i++)
  {
    var pname = vars[i].split('=');
    if (pname[0] == name)
    {
      return pname[1];
    }
  }
}
